// Generated static UI catalog. User-created content is intentionally not included.
module.exports = {
  "Start-parametre": "Start-parametre",
  "Static: persists across runs": "Statisk: vedvarer p\u00e5 tv\u00e6rs af k\u00f8rsler",
  "Status": "Status",
  "Steps": "Trin",
  "steps\u2026": "trin\u2026",
  "Stone": "Sten",
  "Stop": "Stop",
  "Stop (interrupts the AI so you can chat)": "Stop (afbryder AI, s\u00e5 du kan chatte)",
  "Stop & close": "Stop og luk",
  "Store typed context values": "Gem indtastede kontekstv\u00e6rdier",
  "Stream code": "Stream kode",
  "String": "String",
  "Subcategory": "Underkategori",
  "Submit Answers": "Send svar",
  "submitted for review": "indsendt til gennemgang",
  "Success": "Succes",
  "Suggestions": "Forslag",
  "Summary (card subtitle)": "Resum\u00e9 (kort undertekst)",
  "Super Admin": "Super Admin",
  "Svar": "Svar",
  "System": "System",
  "System Objects": "Systemobjekter",
  "System Prompt": "Systemprompt",
  "Tab": "Tab",
  "Tag colors": "Tag farver",
  "Tag name": "Tag navn",
  "Tags": "Tags",
  "Task": "Opgave",
  "Task Prompt": "Opgaveprompt",
  "Teams": "Hold",
  "Template not found.": "Skabelonen blev ikke fundet.",
  "Template Store": "Skabelonbutik",
  "Templates": "Skabeloner",
  "Temporary": "Midlertidig",
  "Terms of service": "Servicevilk\u00e5r",
  "Text": "Tekst",
  "Text to type \u2014 text or @variable": "Tekst at skrive \u2014 tekst eller @variabel",
  "Thanks \u2014 we got it!": "Tak - vi fik det!",
  "That tag already exists for this workflow.": "Dette tag findes allerede for denne workflow.",
  "The agent works from fresh browser screenshots and stops immediately when the Task is visibly complete.": "Agenten arbejder fra nye browser-sk\u00e6rmbilleder og stopper med det samme, n\u00e5r opgaven er synligt fuldf\u00f8rt.",
  "The Alleflow API lets you integrate workflow automation into your own applications. You can create workflows, list existing ones, and retrieve workflow details \u2014 all through simple REST endpoints.": "Alleflow API giver dig mulighed for at integrere workflowautomatisering i dine egne applikationer. Du kan oprette workflows, liste eksisterende og hente workflowdetaljer - alt sammen gennem simple REST-slutpunkter.",
  "The API uses standard HTTP status codes. Errors return a JSON body with an error field.": "API'en bruger standard HTTP-statuskoder. Fejl returnerer en JSON-body med et fejlfelt.",
  "The Google \u201chasn\u2019t verified this app\u201d warning screen \u2014 click Advanced, bottom-left": "Googles advarselssk\u00e6rm \"har ikke bekr\u00e6ftet denne app\" - klik p\u00e5 Avanceret nederst til venstre",
  "the row itself": "selve r\u00e6kken",
  "The run didn't start \u2014 usually a brief connection issue. We already retried once automatically.": "K\u00f8rslen startede ikke - normalt et kort forbindelsesproblem. Vi har allerede pr\u00f8vet igen \u00e9n gang automatisk.",
  "The workflow ID (e.g. wf_abc123).": "Workflow-id'et (f.eks. wf_abc123).",
  "These required fields are still empty. Fill them in and we\u2019ll start QA right after.": "Disse obligatoriske felter er stadig tomme. Udfyld dem, og vi starter QA lige efter.",
  "These run in your Chrome via the Browser Action extension \u2014 they can\u2019t run in the background or be scheduled.": "Disse k\u00f8rer i din Chrome via Browser Action-udvidelsen - de kan ikke k\u00f8re i baggrunden eller planl\u00e6gges.",
  "Thinking...": "T\u00e6nker...",
  "Thinking\u2026": "T\u00e6nker...",
  "This actor documents no input fields \u2014 provide input as JSON below.": "Denne skuespiller dokumenterer ingen inputfelter - giv input som JSON nedenfor.",
  "This actor needs a one-time permission approval before it can run.": "Denne skuespiller skal have en engangstilladelsesgodkendelse, f\u00f8r den kan k\u00f8re.",
  "This cannot be undone.": "Dette kan ikke fortrydes.",
  "This connection was created before multi-account support shipped. Reconnect to get a removable entry.": "Denne forbindelse blev oprettet f\u00f8r multi-konto support blev sendt. Opret forbindelse igen for at f\u00e5 en flytbar post.",
  "This creates the live (production) version that public runs will execute.": "Dette skaber den live (produktions)version, som offentlige k\u00f8rsler vil udf\u00f8re.",
  "This device can:": "Denne enhed kan:",
  "This just bypasses the unverified notice.": "Dette omg\u00e5r bare den ubekr\u00e6ftede meddelelse.",
  "This node has no connected account to choose.": "Denne knude har ingen tilsluttet konto at v\u00e6lge.",
  "This presses Play and waits for the run to finish. Real API calls fire (Slack messages, sheet writes, etc.).": "Dette trykker p\u00e5 Afspil og venter p\u00e5, at l\u00f8beturen er f\u00e6rdig. Rigtige API kalder brand (Slack beskeder, ark skriver osv.).",
  "This setup tab stays open so you can resume recording or continue from it in another Browser Action.": "Denne ops\u00e6tningsfane forbliver \u00e5ben, s\u00e5 du kan genoptage optagelsen eller forts\u00e6tte fra den i en anden browserhandling.",
  "This updates the live (production) version that public runs execute.": "Dette opdaterer den live (produktions)version, som offentligt k\u00f8rer.",
  "This variable is never read or written by any node": "Denne variabel l\u00e6ses eller skrives aldrig af nogen knude",
  "This will remove all nodes and connections from the current workflow canvas.": "Dette vil fjerne alle knuder og forbindelser fra det aktuelle arbejdsflowl\u00e6rred.",
  "This workflow has a published live version": "Denne workflow har en offentliggjort liveversion",
  "This workflow was saved by someone else": "Denne workflow blev gemt af en anden",
  "Thorough \u2014 highest quality": "Grundig - h\u00f8jeste kvalitet",
  "Tick at least one workflow to use as the page backend.": "S\u00e6t kryds ved mindst \u00e9n workflow, der skal bruges som sidens backend.",
  "Tidsplanl\u00e6gning": "Tidsplanl\u00e6gning",
  "Tilga input i downstream-knuder": "Tilga input i downstream-knuder",
  "Tilgaengelige operatorer": "Tilgaengelige operat\u00f8r",
  "Tiloj instruktion": "Tiloj instruktion",
  "Tiloj parametre pa Start-knuden": "Tiloj parametre for Start-knuden",
  "Time": "Tid",
  "Tips": "Tips",
  "Title": "Titel",
  "Title is required.": "Titel er p\u00e5kr\u00e6vet.",
  "Titled context blocks for credentials, API docs, business rules, or domain notes.": "Ben\u00e6vnte kontekstblokke til legitimationsoplysninger, API-dokumenter, forretningsregler eller dom\u00e6netoter.",
  "To page bottom": "Til bunden af siden",
  "Toggle boolean": "Skift boolesk",
  "Toggle playbook explorer": "Skift playbook explorer",
  "Token-forbrug": "Token-forbrug",
  "Tool Calling": "V\u00e6rkt\u00f8jsopkald",
  "Tool description": "V\u00e6rkt\u00f8jsbeskrivelse",
  "Total": "I alt",
  "Total Tokens": "Samlede tokens",
  "Trace your variables": "Spor dine variabler",
  "Traek knuder fra sidepanelet (System Objects) ud pa canvas. Forbind dem ved at traeke fra et udgaende anker (hojre side) til et indgaende anker (venstre side). Forbindelserne bestemmer udforelsesraekkefolgen.": "Traek knuder fra sidepanelet (System Objects) ud p\u00e5 l\u00e6rred. Forbind dem ved at traeke fra et udgaende anker (hojre side) til et indgaende anker (venstre side). Forbindelserne bestemmer udforelsesraekkefolgen.",
  "True": "Sandt",
  "True / False": "Sandt / falsk",
  "Trusted & used in projects": "P\u00e5lidelig og brugt i projekter",
  "Tryk pa play-knappen i footeren. Resultater streames i realtid. Tryk stop for at afbryde. Har du Start-parametre, vises en formular forst.": "Tryk p\u00e5 play-knappen i footeren. resultater streames i realtid. Tryk stop for at afbryde. Har du Start-parametre, vises en formular forst.",
  "Turn on the debugger": "T\u00e6nd for debuggeren",
  "Enter a stream code above, then turn this on to wait for live events sent to the public run endpoint with that code.": "Indtast en stream-kode ovenfor, og sl\u00e5 derefter dette til for at vente p\u00e5 livebegivenheder sendt til det offentlige k\u00f8rselsslutpunkt med den kode.",
  "Enter the stream code to listen for": "Indtast den stream-kode, der skal lyttes efter",
  "Use this code": "Brug denne kode",
  "Type": "Type",
  "Type a reply...": "Skriv et svar...",
  "Type a value or @ to reference a variable": "Indtast en v\u00e6rdi eller @ for at referere til en variabel",
  "Type your answer in the box below.": "Skriv dit svar i feltet nedenfor.",
  "Type your answer...": "Skriv dit svar...",
  "typeEnter": "typeEnter",
  "Typing delay (ms per character)": "Indtastningsforsinkelse (ms pr. tegn)",
  "UCPIM": "UCPIM",
  "Uge": "Uge",
  "UI": "UI",
  "UI page not found.": "UI-siden blev ikke fundet.",
  "UI page ready": "UI-siden klar",
  "UI Pages": "UI sider",
  "UI Planner": "UI Planner",
  "UI select": "V\u00e6lg UI",
  "Unauthorized": "Uautoriseret",
  "Understottede typer": "Understottede typer",
  "Undo": "Fortryd",
  "Ungroup": "Oph\u00e6v grupperingen",
  "Ungroup and restore nodes": "Oph\u00e6v gruppering og gendan knuder",
  "Uniconta": "Uniconta",
  "Unit": "Enhed",
  "Unknown error": "Ukendt fejl",
  "Unlock node": "L\u00e5s knude op",
  "Unnamed": "Unavngivet",
  "Unpublish": "Fjern udgivelse",
  "Unpublish failed": "Offentligg\u00f8relse mislykkedes",
  "Untitled": "Uden titel",
  "Untitled page": "Unavngivet side",
  "Untitled playbook": "Unavngivet spillebog",
  "Up": "Op",
  "Update a variable at runtime": "Opdater en variabel ved k\u00f8rsel",
  "Update Code": "Opdater kode",
  "Update from staging": "Opdatering fra iscenes\u00e6ttelse",
  "Update Page": "Opdater side",
  "Update password": "Opdater adgangskode",
  "Update Settings": "Opdater indstillinger",
  "Updated": "Opdateret",
  "Updating...": "Opdaterer...",
  "Upload": "Upload",
  "Upload failed.": "Upload mislykkedes.",
  "Uploading...": "Uploader...",
  "Usage": "Brug",
  "Use a computer terminal to use tool and complete the task": "Brug en computerterminal til at bruge v\u00e6rkt\u00f8jet og fuldf\u00f8re opgaven",
  "Use at least 6 characters. After updating, other devices will be signed out.": "Brug mindst 6 tegn. Efter opdatering vil andre enheder blive logget ud.",
  "Use Gmail, Calendar, and Drive from workflow nodes through any of your saved Google accounts.": "Brug Gmail, Kalender og Drev fra workflow-knuder gennem enhver af dine gemte Google-konti.",
  "Use Outlook Mail, Calendar, and OneDrive from workflow nodes through any of your saved Microsoft accounts.": "Brug Outlook Mail, Kalender og OneDrive fra workflow-knuder gennem enhver af dine gemte Microsoft-konti.",
  "Use the array length (number of items)": "Brug array-l\u00e6ngden (antal elementer)",
  "Use the X-API-Key header to authenticate requests to the /v1 API:": "Brug X-API-Key-headeren til at godkende anmodninger til /v1 API:",
  "User account": "Brugerkonto",
  "Username": "Brugernavn",
  "Users": "Brugere",
  "Using your connected": "Bruger din tilsluttede",
  "Value": "V\u00e6rdi",
  "Value \u25cf": "V\u00e6rdi \u25cf",
  "value or @variable": "v\u00e6rdi eller @variabel",
  "value or select variable": "v\u00e6rdi eller v\u00e6lg variabel",
  "Value persists across runs": "V\u00e6rdien best\u00e5r p\u00e5 tv\u00e6rs af k\u00f8rsler",
  "Value resets each run": "V\u00e6rdien nulstilles hver k\u00f8rsel",
  "Variable": "Variabel",
  "Variable changes stay only in the current run": "Variable \u00e6ndringer forbliver kun i den aktuelle k\u00f8rsel",
  "variable name": "variabel navn",
  "Variable name": "Variabel navn",
  "Variable too big": "Variabel for stor",
  "Variable values are not copied to the live version.": "Variabelv\u00e6rdier kopieres ikke til liveversionen.",
  "Variabler": "Variabler",
  "Variables": "Variabler",
  "Ved API-kald sendes parametrene som JSON body i POST-requestet til /v1/workflows/:id/execute.": "Ved API-kald sendes parametrene som JSON-kroppen i POST-requestet til /v1/workflows/:id/execute.",
  "Verification in progress": "Verifikation i gang",
  "Version history": "Versionshistorik",
  "Version notes (optional)": "Versionsbem\u00e6rkninger (valgfrit)",
  "Via API": "Via API",
  "View and restore previous saved versions": "Se og gendan tidligere gemte versioner",
  "View In Public": "Vis offentligt",
  "View node output": "Se nodeoutput",
  "VS Code - Light": "VS-kode - lys",
  "Waiting": "Venter",
  "Waiting for stream code...": "Venter p\u00e5 stream-kode...",
  "Warning": "Advarsel",
  "We\u2019re still completing Google\u2019s verification process, so Google shows an \u201cunverified app\u201d notice for now. It\u2019s a routine step, not a security problem \u2014 thousands of trusted apps go through it. Your Google password is never shared with us, you choose exactly what to allow, and you can disconnect anytime. Here\u2019s how to continue:": "Vi er stadig ved at fuldf\u00f8re Googles bekr\u00e6ftelsesproces, s\u00e5 Google viser en \"ubekr\u00e6ftet app\"-meddelelse indtil videre. Det er et rutinetrin, ikke et sikkerhedsproblem - tusindvis af betroede apps g\u00e5r igennem det. Din Google-adgangskode deles aldrig med os, du v\u00e6lger pr\u00e6cis, hvad du vil tillade, og du kan afbryde forbindelsen n\u00e5r som helst. S\u00e5dan forts\u00e6tter du:",
  "Webpage URL": "Webside URL",
  "Weekly": "Ugentligt",
  "What should be classified?": "Hvad skal klassificeres?",
  "What should the pointer rest on? e.g. \"the checkout button\" \u00b7 or @variable": "Hvad skal mark\u00f8ren hvile p\u00e5? f.eks. \"kasseknappen\" \u00b7 eller @variable",
  "What should this AI do?": "Hvad skal denne AI g\u00f8re?",
  "What to do": "Hvad skal man g\u00f8re",
  "What to do next": "Hvad skal man s\u00e5 g\u00f8re",
  "What went wrong": "Hvad gik galt",
  "What works, what doesn\u2019t, what would you love to see?": "Hvad virker, hvad g\u00f8r ikke, hvad ville du elske at se?",
  "What\u2019s new in": "Hvad er nyt i",
  "What's Next?": "Hvad er det n\u00e6ste?",
  "When enabled, the builder switches to listening mode until you turn it off.": "N\u00e5r den er aktiveret, skifter builderen til lyttetilstand, indtil du slukker den.",
  "When everything works": "N\u00e5r alt virker",
  "When something goes wrong": "N\u00e5r noget g\u00e5r galt",
  "Widget": "Widget",
  "Workflow": "Workflow",
  "Workflow actions": "Arbejdsgangshandlinger",
  "Workflow built successfully!": "Workflow bygget med succes!",
  "Workflow canvas preview": "Forh\u00e5ndsvisning af arbejdsflowl\u00e6rred",
  "Workflow context": "Workflow kontekst",
  "Workflow Copilot": "Workflow Copilot",
  "Workflow Doctor": "workflow l\u00e6ge",
  "Workflow Error": "Arbejdsgangsfejl",
  "Workflow library": "Workflow bibliotek",
  "Workflow overview": "Oversigt over workflows",
  "Workflow plan": "Arbejdsgangsplan",
  "Workflow Plan": "Arbejdsgangsplan",
  "Workflow-k\u00f8rsler": "Workflow-k\u00f8rsler",
  "Workflows": "Workflows",
  "Working": "Arbejder",
  "working\u2026": "arbejder\u2026",
  "Working\u2026": "Arbejder...",
  "Yes": "Ja",
  "Yes, delete": "Ja, slet",
  "You": "Dig",
  "You are a helpful AI assistant.": "Du er en hj\u00e6lpsom AI-assistent.",
  "You\u2019re connected. Revoke anytime.": "Du er forbundet. Tilbagekald n\u00e5r som helst.",
  "You\u2019re safe \u2014 the next screen just looks scary.": "Du er sikker - den n\u00e6ste sk\u00e6rm ser bare skr\u00e6mmende ud.",
  "You\u2019ve published this workflow before": "Du har udgivet denne workflow f\u00f8r",
  "you@example.com": "dig@eksempel.com",
  "you@example.com \u2014 so we can reply": "you@example.com \u2014 s\u00e5 vi kan svare",
  "Your API keys": "Dine API-n\u00f8gler",
  "Your data, protected": "Dine data, beskyttet",
  "Your edits are auto-saved as a local draft. Click Save to push to the server.": "Dine redigeringer gemmes automatisk som en lokal kladde. Klik p\u00e5 Gem for at skubbe til serveren.",
  "Your email": "Din e-mail",
  "Your feedback": "Din feedback",
  "Your Files": "Dine filer",
  "Your page is ready in the preview on the right.": "Din side er klar i forh\u00e5ndsvisningen til h\u00f8jre.",
  "Your sign-in username. To change it, contact support.": "Dit login-brugernavn. Kontakt support for at \u00e6ndre det.",
  "Your UI page will appear here once the planner generates it.": "Din UI-side vises her, n\u00e5r planl\u00e6ggeren genererer den.",
  "Your workflow couldn\u2019t finish": "Din workflow kunne ikke afsluttes",
  "Your tailored workflow suggestions will appear here.": "Dine tilpassede workflowforslag vises her.",
  "Your workflow will appear here once the plan is ready.": "Din workflow vises her, n\u00e5r planen er klar.",
  "Start with a few words, then keep asking questions and refining ideas for as long as you need.": "Start med et par ord, og bliv derefter ved med at stille sp\u00f8rgsm\u00e5l og finpudse ideer, s\u00e5 l\u00e6nge du har brug for det.",
  "Automate a task": "Automatiser en opgave",
  "Based on what you told me. Pick one and I\u2019ll build it.": "Baseret p\u00e5 det, du har fortalt. V\u00e6lg et forslag, s\u00e5 bygger jeg det.",
  "Best matches": "Bedste match",
  "Build this workflow": "Byg dette workflow",
  "Chase unpaid invoices": "F\u00f8lg op p\u00e5 ubetalte fakturaer",
  "Chasing unpaid invoices": "Rykke for ubetalte fakturaer",
  "Choose a starting point. I\u2019ll tailor it to your connected accounts.": "V\u00e6lg et startpunkt. Jeg tilpasser det til dine tilknyttede konti.",
  "Copying data between systems": "Kopiere data mellem systemer",
  "Describe what you want to automate in your own words, or start manually.": "Beskriv med dine egne ord, hvad du vil automatisere, eller start manuelt.",
  "Describe the task, or just tell me about your day\u2026": "Beskriv opgaven, eller fort\u00e6l mig bare om din dag\u2026",
  "Request plan changes...": "Bed om \u00e6ndringer i planen...",
  "Describe what you want to happen. Mention the apps or information involved if you know them \u2014 I'll ask only for anything essential.": "Beskriv, hvad der skal ske. N\u00e6vn de apps eller oplysninger, der indg\u00e5r, hvis du kender dem \u2014 jeg sp\u00f8rger kun om det n\u00f8dvendige.",
  "Explore this idea": "Udforsk denne id\u00e9",
  "Find urgent customer messages and get each request to the right person.": "Find vigtige kundebeskeder, og send hver henvendelse til den rette person.",
  "Follow up consistently without checking accounts and writing reminders by hand.": "F\u00f8lg konsekvent op uden manuelt at kontrollere konti og skrive rykkere.",
  "Guided": "Guidet",
  "Guided setup": "Guidet ops\u00e6tning",
  "Helper": "Hj\u00e6lper",
  "I keep copying the same information between emails, spreadsheets, and business systems.": "Jeg bliver ved med at kopiere de samme oplysninger mellem e-mails, regneark og forretningssystemer.",
  "I spend too much time checking and chasing unpaid invoices.": "Jeg bruger for meget tid p\u00e5 at kontrollere og rykke for ubetalte fakturaer.",
  "I want one short weekly overview of the important things in my business without collecting it manually.": "Jeg vil have \u00e9n kort ugentlig oversigt over det vigtigste i min virksomhed uden at samle den manuelt.",
  "INVOICES": "FAKTURAER",
  "CUSTOMERS": "KUNDER",
  "Model quality": "Modelkvalitet",
  "Move customer, order, or invoice details between the tools you already use.": "Flyt kunde-, ordre- eller fakturaoplysninger mellem de v\u00e6rkt\u00f8jer, du allerede bruger.",
  "Planning mode": "Planl\u00e6gningstilstand",
  "Preparing weekly updates": "Forberede ugentlige statusser",
  "Preparing your workflow...": "Forbereder dit workflow...",
  "ready \u2014 pick one in the panel on the right.": "klar \u2014 v\u00e6lg et forslag i panelet til h\u00f8jre.",
  "Receive one useful overview of open work, customers, and finances.": "F\u00e5 \u00e9n nyttig oversigt over \u00e5bent arbejde, kunder og \u00f8konomi.",
  "Show advanced planning options": "Vis avancerede planl\u00e6gningsindstillinger",
  "Sort customer requests": "Sorter kundehenvendelser",
  "Sorting and forwarding customer requests takes too much of my day.": "Det tager for meget af min dag at sortere og videresende kundehenvendelser.",
  "Sorting customer requests": "Sortere kundehenvendelser",
  "Start from an example": "Start med et eksempel",
  "Starting points": "Startpunkter",
  "Stop copy-pasting": "Stop med at kopiere og inds\u00e6tte",
  "Suggest a workflow": "Foresl\u00e5 et workflow",
  "Suggested workflows": "Foresl\u00e5ede workflows",
  "Suggest a workflow is ON \u2014 I ask simple questions and suggest workflows you can pick. Click to switch back to the planner.": "Foresl\u00e5 et workflow er SL\u00c5ET TIL \u2014 jeg stiller enkle sp\u00f8rgsm\u00e5l og foresl\u00e5r workflows, du kan v\u00e6lge. Klik for at skifte tilbage til planl\u00e6ggeren.",
  "Not sure what to build? Turn this on and I\u2019ll ask simple questions, then suggest workflows you can pick.": "Ikke sikker p\u00e5, hvad du skal bygge? Sl\u00e5 dette til, s\u00e5 stiller jeg enkle sp\u00f8rgsm\u00e5l og foresl\u00e5r workflows, du kan v\u00e6lge.",
  "Use detailed planner": "Brug detaljeret planl\u00e6gger",
  "Use guided helper": "Brug guidet hj\u00e6lp",
  "Weekly owner summary": "Ugentlig ejeroversigt",
  "WEEKLY": "UGENTLIG",
  "What would you like to automate?": "Hvad vil du gerne automatisere?",
  "Workflow planner": "Workflowplanl\u00e6gger",
  "workflow suggestion": "workflowforslag",
  "workflow suggestions": "workflowforslag",
  "YouTube demo video (optional)": "YouTube-demovideo (valgfrit)"
};
